import { Controller } from "@hotwired/stimulus"

// A badge grid that shows its first two rows until asked for the rest. The
// server renders the tiles past the fold with `hidden` and marks them as
// `extra`; the toggle flips them and its own label between
// "Show all <count> <noun>" and "Show fewer".
export default class extends Controller {
  static targets = ["extra", "toggle"]
  static values = { count: Number, noun: String }

  toggle() {
    const expanded = this.toggleTarget.getAttribute("aria-expanded") === "true"
    this.extraTargets.forEach((tile) => { tile.hidden = expanded })
    this.toggleTarget.setAttribute("aria-expanded", String(!expanded))
    this.toggleTarget.textContent = expanded ? `Show all ${this.countValue} ${this.nounValue}` : "Show fewer"
  }
}
